
import { CheckCircleFilled } from "@ant-design/icons";
import { Template } from "../../Step1";
import { Button } from "Components";
import { DIFFICULTY_COLOR } from "../../../PhishingManager.constants";

type TemplateCardProps = {
  template: Template;
  selected: boolean;
  onSelect: (id: string | number | null) => void;
};

export default function TemplateCard({ template, selected, onSelect }: TemplateCardProps) {
  const diff = DIFFICULTY_COLOR[template.difficulty] || DIFFICULTY_COLOR.Beginner;
  return (
    <div className="cs-template-card-wrapper">
      <div className="cs-template-img">
        <img src={template?.img || "./placeholderImage.png"} alt={template.label} className="cs-image-cover" />
        <span className="cs-image-word-cover" style={{ background: diff.bg, color: diff.color}}>
          {template.difficulty}
        </span>
        {selected && (
          <div className="cs-selected-checkbox">
            <CheckCircleFilled className="text-white fsx-16" />
          </div>
        )}
      </div>

      <div className="cs-template-card">
        <div className="cs-template-card-title">
          {template.label}
        </div>
        <div className="cs-template-card-category">
          {template.categories?.length ? template.categories?.join(", ") : ""}
        </div>
      </div>

      <Button shape="round" type="primary" onClick={(e) => {
        e.stopPropagation();
        selected ? onSelect(null) : onSelect(template.value);
      }}>{selected ? "Selected" : "Select"}</Button>
    </div>
  );
}